export * from "./mixpanel";

export enum HeaderEvents {
  CLICKED_HEADER_LOGO = "clicked_header_logo",
  NAVIGATE_TO_FEED_FROM_HOME = "navigate_to_feed_from_home",
  CLICKED_SUBSCRIBE_FROM_HEADER = "clicked_subscribe_from_header",
  CLICKED_SIGN_IN = "clicked_sign_in",
  CLICKED_PRIVACY_POLICY = "clicked_privacy_policy",
  CLICKED_TERMS_OF_SERVICE = "clicked_terms_of_service",
  CLICKED_ABOUT_US = "clicked_about_us",
  CLICKED_TIXOLOGI = "clicked_tixologi",
  CLICKED_BLOG = "clicked_blog",
}

export enum CommentEvents {
  // Section-level events
  COMMENT_SECTION_LOADED = "Comment Section Loaded",
  COMMENT_SECTION_ERROR = "Comment Section Error",
  COMMENT_FEATURE_DISABLED = "Comment Feature Disabled",

  // Comment submission events
  COMMENT_SUBMITTED = "Comment Submitted",
  COMMENT_SUBMIT_FAILED = "Comment Submit Failed",
  REPLY_SUBMITTED = "Reply Submitted",
  REPLY_SUBMIT_FAILED = "Reply Submit Failed",
  ARTIST_COMMENT_POSTED = "Artist Comment Posted",

  // Comment interaction events
  COMMENT_EDITED = "Comment Edited",
  COMMENT_DELETED = "Comment Deleted",
  COMMENT_CLAP_CLICKED = "Comment Clap Clicked",
  COMMENT_CLAP_SUBMITTED = "Comment Clap Submitted",

  // Reply events
  REPLY_BUTTON_CLICKED = "Reply Button Clicked",
  REPLIES_EXPANDED = "Replies Expanded",
  REPLIES_COLLAPSED = "Replies Collapsed",

  // Input events
  COMMENT_INPUT_FOCUSED = "Comment Input Focused",
  COMMENT_INPUT_BLURRED = "Comment Input Blurred",
  COMMENT_INPUT_TYPING = "Comment Input Typing",
  COMMENT_VALIDATION_FAILED = "Comment Validation Failed",
  REPLY_INPUT_OPENED = "Reply Input Opened",

  // Load more and refresh events
  COMMENTS_LOAD_MORE_CLICKED = "Comments Load More Clicked",
  COMMENTS_REFRESH_CLICKED = "Comments Refresh Clicked",
  COMMENTS_NEW_AVAILABLE_CLICKED = "Comments New Available Clicked",

  // Mobile modal events
  MOBILE_COMMENT_MODAL_OPENED = "Mobile Comment Modal Opened",
  MOBILE_COMMENT_MODAL_CLOSED = "Mobile Comment Modal Closed",
  MOBILE_COMMENT_PREVIEW_CLICKED = "Mobile Comment Preview Clicked",
}
